import { ModuleFE_SimulationDemoEvent } from './ModuleFE_SimulationDemoEvent.js';
export const ModulePackFE_SimulationDemoEvent = [ModuleFE_SimulationDemoEvent];
//# sourceMappingURL=module-pack.js.map